import { useNavigate } from "react-router-dom";
import { CompositeEditor } from "@/components/talent/Composites/CompositeEditor";

export function CreateCompositePage() {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="flex min-h-screen w-full flex-col">
      <CompositeEditor mode="create" onCancel={handleCancel} />
    </div>
  );
}
